"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteSearchContext = void 0;
var _react = require("react");
// a react context for site search share results and setting functions

const SiteSearchContext = exports.SiteSearchContext = /*#__PURE__*/(0, _react.createContext)();